import React from 'react';
import { CarouselSnapped, CarouselSnappedSlide } from '@andes/carousel-snapped';
import classNames from 'classnames';
import { Modal } from '@andes/modal';
import { Button } from '@andes/button';
import { Card, CardContent } from '@andes/card';
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var namespace = 'ui-ms-coupons-modal';
var CouponModal = function CouponModal(_ref) {
  var title = _ref.title,
    image = _ref.image,
    deviceType = _ref.deviceType,
    buttonPrimary = _ref.button_text_primary,
    buttonSecondary = _ref.button_text_secondary,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    _ref$onClickPrimary = _ref.onClickPrimary,
    onClickPrimary = _ref$onClickPrimary === void 0 ? function () {} : _ref$onClickPrimary,
    _ref$onClickSecondary = _ref.onClickSecondary,
    onClickSecondary = _ref$onClickSecondary === void 0 ? function () {} : _ref$onClickSecondary;
  var classModal = classNames(namespace, _defineProperty({}, "".concat(namespace, "--desktop"), deviceType === 'desktop'));
  return /*#__PURE__*/_createRawReactElement(Modal, {
    open: active,
    onClose: onClose,
    className: classModal,
    closable: false
  }, void 0, /*#__PURE__*/_createRawReactElement("div", {
    className: "".concat(namespace, "__body")
  }, void 0, /*#__PURE__*/_createRawReactElement("div", {
    className: "".concat(namespace, "__image")
  }, void 0, /*#__PURE__*/_createRawReactElement("img", {
    src: image,
    alt: title
  })), /*#__PURE__*/_createRawReactElement("p", {}, void 0, title), /*#__PURE__*/_createRawReactElement("div", {
    className: "".concat(namespace, "__actions")
  }, void 0, buttonPrimary && /*#__PURE__*/_createRawReactElement(Button, {
    hierarchy: "loud",
    size: "large",
    onClick: onClickPrimary
  }, void 0, buttonPrimary), buttonSecondary && /*#__PURE__*/_createRawReactElement(Button, {
    hierarchy: "transparent",
    onClick: onClickSecondary
  }, void 0, buttonSecondary))));
};
var CouponModal$1 = CouponModal;
var CouponsContainer = function CouponsContainer(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$namespace = _ref.namespace,
    namespace = _ref$namespace === void 0 ? 'ui-ms-coupons-container' : _ref$namespace,
    children = _ref.children,
    _ref$modal = _ref.modal,
    modal = _ref$modal === void 0 ? {} : _ref$modal,
    deviceType = _ref.deviceType,
    coupons = _ref.coupons,
    isEditable = _ref.isEditable,
    _ref$modalActions = _ref.modalActions,
    modalActions = _ref$modalActions === void 0 ? {
      onClickPrimary: function onClickPrimary() {},
      onClickSecondary: function onClickSecondary() {},
      onClose: function onClose() {}
    } : _ref$modalActions;
  var haveCoupons = (coupons === null || coupons === void 0 ? void 0 : coupons.length) > 0;
  var classContainer = classNames(namespace, _defineProperty({}, "".concat(namespace, "--empty"), !haveCoupons && !isEditable));
  return /*#__PURE__*/_createRawReactElement("div", {
    className: classContainer
  }, void 0, title && /*#__PURE__*/_createRawReactElement("div", {
    className: "".concat(namespace, "__head")
  }, void 0, /*#__PURE__*/_createRawReactElement("h3", {}, void 0, title)), haveCoupons && /*#__PURE__*/_createRawReactElement("div", {
    className: "".concat(namespace, "__body")
  }, void 0, children), /*#__PURE__*/React.createElement(CouponModal$1, _extends({}, modal, {
    deviceType: deviceType,
    onClickPrimary: modalActions === null || modalActions === void 0 ? void 0 : modalActions.onClickPrimary,
    onClickSecondary: modalActions === null || modalActions === void 0 ? void 0 : modalActions.onClickSecondary,
    onClose: modalActions === null || modalActions === void 0 ? void 0 : modalActions.onClose
  })));
};
var CouponsContainer$1 = CouponsContainer;
var _svg;
var IconDeal = function IconDeal() {
  return _svg || (_svg = /*#__PURE__*/_createRawReactElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "41",
    height: "40",
    fill: "none",
    viewBox: "0 0 41 40"
  }, void 0, /*#__PURE__*/_createRawReactElement("path", {
    fill: "#EEE",
    stroke: "#fff",
    strokeWidth: "1.183",
    d: "M36.397 22.133l.68 4.824-30.472 4.265-.68-4.824A3.895 3.895 0 004.85 18.78l-.681-4.824L34.64 9.691l.68 4.824a3.895 3.895 0 001.075 7.618z"
  }), /*#__PURE__*/_createRawReactElement("path", {
    stroke: "#9B9B9B",
    strokeDasharray: "2.37",
    strokeWidth: "0.592",
    d: "M9.641 12.593l2.602 18.437M29.286 9.843l2.602 18.438"
  }), /*#__PURE__*/_createRawReactElement("path", {
    stroke: "#9B9B9B",
    strokeWidth: "0.592",
    d: "M35.144 9.023l.84 5.952a3.29 3.29 0 00-2.797 3.723 3.3 3.3 0 003.607 2.825l.112-.013.84 5.95-31.644 4.43-.84-5.952a3.29 3.29 0 002.796-3.723 3.3 3.3 0 00-3.606-2.825l-.112.014-.84-5.952 31.644-4.429z",
    clipRule: "evenodd"
  })));
};
var IconDeal$1 = IconDeal;
var _IconDeal;
var EmptyCard = function EmptyCard(_ref) {
  var text = _ref.text,
    _ref$namespace = _ref.namespace,
    namespace = _ref$namespace === void 0 ? 'ui-ms-coupons-empty-card' : _ref$namespace;
  return /*#__PURE__*/_createRawReactElement("div", {
    className: namespace
  }, void 0, /*#__PURE__*/_createRawReactElement(Card, {
    paddingSize: 24
  }, void 0, /*#__PURE__*/_createRawReactElement(CardContent, {}, void 0, _IconDeal || (_IconDeal = /*#__PURE__*/_createRawReactElement(IconDeal$1, {})), /*#__PURE__*/_createRawReactElement("h3", {
    className: "".concat(namespace, "__text")
  }, void 0, text))));
};
var EmptyCard$1 = EmptyCard;
var CONFIG_BY_DEVICE = {
  desktop: {
    slidesPerView: 3,
    spacing: 16,
    arrows: {
      size: 'large',
      visibility: 'always'
    },
    pagination: {
      mode: 'dark',
      position: 'bottom'
    },
    scroll: 'hidden',
    thresholdSlide: 50,
    type: 'content'
  },
  mobile: {
    slidesPerView: 1,
    thresholdSlide: 1,
    spacing: 8,
    arrows: false,
    type: 'content'
  }
};
var DEFAULT_THEME = {
  title_page: {},
  id_coupon: 10909430,
  id_campaign: '10909430',
  background_color: '#F5F5F5',
  margin_vertical: null,
  margin_horizontal: null,
  icon: 'furniture',
  code: 'xxxxxxxxxx',
  user_id: 1724467207,
  title: {
    text: '5% OFF ',
    color: '#000',
    bg_color: '#4189e633',
    font_size: 'LARGE',
    under_line: false
  },
  subtitle: {
    text: 'En productos seleccionados',
    color: 'black_primary',
    font_size: 'XSMALL',
    under_line: false
  },
  min_purchase: {
    purchase_text: {
      text: 'Compra mínima',
      color: 'andes-text-color-secondary',
      font_size: 'XSMALL',
      under_line: false
    },
    currency_id: 'ARS',
    value: 50000
  },
  max_amount: {
    purchase_text: {
      text: 'Tope de',
      color: 'andes-text-color-secondary',
      font_size: 'XSMALL',
      under_line: false
    },
    currency_id: 'ARS',
    value: 2500
  },
  expiration_info: {
    type: 'future',
    expiration_text: {
      text: 'Vence 14 de marzo',
      under_line: false
    }
  },
  button_text_primary: {
    text: 'Aplicar',
    under_line: false
  },
  button_text_secondary: {
    text: 'Aplicado...',
    under_line: false
  },
  track_view: {},
  track_event: {}
};
var THEMES = {
  eshops: DEFAULT_THEME
};
var eshops = THEMES.eshops;
var overrideThemeProperties = function overrideThemeProperties() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? eshops : _ref$theme,
    _ref$properties = _ref.properties,
    properties = _ref$properties === void 0 ? {} : _ref$properties,
    _ref$trackAppliedCoup = _ref.trackAppliedCoupon,
    trackAppliedCoupon = _ref$trackAppliedCoup === void 0 ? {} : _ref$trackAppliedCoup,
    _ref$trackApplyCoupon = _ref.trackApplyCoupon,
    trackApplyCoupon = _ref$trackApplyCoupon === void 0 ? {} : _ref$trackApplyCoupon;
  var newTheme = _objectSpread2(_objectSpread2({}, theme), {}, {
    id_coupon: properties.id,
    title: _objectSpread2(_objectSpread2({}, theme.title), {}, {
      text: properties.title
    }),
    subtitle: _objectSpread2(_objectSpread2({}, theme.subtitle), {}, {
      text: properties.subtitle
    }),
    type: properties.type,
    card_type: properties.card_type,
    icon: properties.icon,
    url: properties.url,
    isApplied: properties.is_applied,
    min_purchase: _objectSpread2(_objectSpread2({}, theme.min_purchase), {}, {
      purchase_text: _objectSpread2(_objectSpread2({}, theme.min_purchase.purchase_text), {}, {
        text: properties.min_purchase.text
      }),
      currency_id: properties.currency_id,
      value: properties.min_purchase.value
    }),
    max_amount: _objectSpread2(_objectSpread2({}, theme.max_amount), {}, {
      purchase_text: _objectSpread2(_objectSpread2({}, theme.max_amount.purchase_text), {}, {
        text: properties.max_purchase.text
      }),
      currency_id: properties.currency_id,
      value: properties.max_purchase.value
    }),
    expiration_info: _objectSpread2(_objectSpread2({}, theme.expiration_info), {}, {
      expiration_text: _objectSpread2(_objectSpread2({}, theme.expiration_info.expiration_text), {}, {
        text: properties.expiration_info.text
      })
    }),
    button_text_primary: _objectSpread2(_objectSpread2({}, theme.button_text_primary), {}, {
      text: properties.button_text_primary,
      text_applied: properties.button_text_applied
    }),
    button_text_secondary: _objectSpread2(_objectSpread2({}, theme.button_text_secondary), {}, {
      text: properties.button_text_secondary
    }),
    track_event: {
      applied_coupon: trackAppliedCoupon,
      melidata_event: trackApplyCoupon
    }
  });
  return newTheme;
};
var overrideThemeProperties$1 = overrideThemeProperties;
var Coupon = require('@recommendations-fe/coupon');
var IconFactory = require('@recommendations-fe/icons/factory-builder');
var IconClock = require('@recommendations-fe/icons/icon-clock');
var IconBadge = require('@recommendations-fe/icons/icon-badge');
var IconBeauty = require('@recommendations-fe/icons/icon-beauty');
var IconClothing = require('@recommendations-fe/icons/icon-clothing');
var IconDeco = require('@recommendations-fe/icons/icon-deco');
var IconFire = require('@recommendations-fe/icons/icon-fire');
var IconInfo = require('@recommendations-fe/icons/icon-info');
var IconSupermarket = require('@recommendations-fe/icons/icon-supermarket');
var IconTools = require('@recommendations-fe/icons/icon-tools');
var IconStore = require('@recommendations-fe/icons/icon-store');
var CouponWrapper = function CouponWrapper(_ref) {
  var coupon = _ref.coupon,
    applyCoupon = _ref.applyCoupon,
    getCampaignInfo = _ref.getCampaignInfo,
    isDesktop = _ref.isDesktop,
    trackAppliedCoupon = _ref.trackAppliedCoupon,
    trackApplyCoupon = _ref.trackApplyCoupon;
  return /*#__PURE__*/_createRawReactElement(Coupon, {
    isCouponExperience: true,
    data: overrideThemeProperties$1({
      properties: coupon,
      trackAppliedCoupon: trackAppliedCoupon,
      trackApplyCoupon: trackApplyCoupon
    }),
    activate: applyCoupon,
    campaign: getCampaignInfo,
    isDesktop: isDesktop,
    iconFactory: IconFactory([IconClock, IconBadge, IconBeauty, IconClothing, IconDeco, IconFire, IconInfo, IconSupermarket, IconTools, IconStore])
  });
};
var CouponWrapper$1 = CouponWrapper;
var CouponCarousel = function CouponCarousel(props) {
  var deviceType = props.deviceType,
    coupons = props.coupons,
    emptyCard = props.empty_card,
    isEditable = props.isEditable,
    _applyCoupon = props.applyCoupon,
    _getCampaignInfo = props.getCampaignInfo,
    _props$initialSlide = props.initialSlide,
    initialSlide = _props$initialSlide === void 0 ? 0 : _props$initialSlide,
    trackAppliedCoupon = props.trackAppliedCoupon,
    trackApplyCoupon = props.trackApplyCoupon;
  var isMobile = deviceType === 'mobile';
  var carouselSettings = _objectSpread2(_objectSpread2({}, CONFIG_BY_DEVICE[deviceType]), {}, {
    initialSlide: initialSlide,
    pagination: isMobile ? true : coupons.length > 4
  });
  if (isEditable && (coupons === null || coupons === void 0 ? void 0 : coupons.length) === 0) {
    return /*#__PURE__*/_createRawReactElement(EmptyCard$1, {
      text: emptyCard.text
    });
  }
  if (isMobile && coupons.length === 1) {
    var onlyCoupon = coupons[0];
    return /*#__PURE__*/React.createElement(CouponsContainer$1, props, /*#__PURE__*/_createRawReactElement(CouponWrapper$1, {
      isDesktop: !isMobile,
      coupon: onlyCoupon,
      trackAppliedCoupon: trackAppliedCoupon,
      trackApplyCoupon: trackApplyCoupon,
      applyCoupon: function applyCoupon() {
        return _applyCoupon({
          campaignId: onlyCoupon.id,
          code: onlyCoupon.code
        });
      },
      getCampaignInfo: function getCampaignInfo() {
        return _getCampaignInfo({
          campaignId: onlyCoupon.id,
          code: onlyCoupon.code
        });
      }
    }));
  }
  return /*#__PURE__*/React.createElement(CouponsContainer$1, props, /*#__PURE__*/React.createElement(CarouselSnapped, carouselSettings, coupons.map(function (coupon, index) {
    return /*#__PURE__*/_createRawReactElement(CarouselSnappedSlide, {}, coupon.id, /*#__PURE__*/_createRawReactElement(CouponWrapper$1, {
      coupon: coupon,
      trackAppliedCoupon: trackAppliedCoupon,
      trackApplyCoupon: trackApplyCoupon,
      applyCoupon: function applyCoupon() {
        return _applyCoupon({
          campaignId: coupon.id,
          code: coupon.code,
          index: index
        });
      },
      getCampaignInfo: function getCampaignInfo() {
        return _getCampaignInfo({
          campaignId: coupon.id,
          code: coupon.code
        });
      },
      isDesktop: !isMobile
    }));
  })));
};
var CouponCarousel$1 = CouponCarousel;
export { CouponCarousel$1 as CouponCarousel, CouponCarousel$1 as default };
